import React, { ReactElement } from 'react';
import { formatTranslation } from 'intl';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import DeleteIcon from '@mui/icons-material/Delete';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useIntl } from 'react-intl';
import type { ApproverRowProps } from './types';
import { WorkflowTranslationKeys } from 'intl/keys';
import {
  approverRowSx,
  getDragHandleSx,
  getApproverTextSx,
  approverIndexSx,
  deleteButtonSx,
} from './styles';

export function ApproverRow({
  approver,
  index,
  onDelete,
  disabled,
  deleteDisabled = false,
}: ApproverRowProps): ReactElement {
  const intl = useIntl();
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({
      id: approver._id,
    });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  const deleteTooltip = formatTranslation(intl, WorkflowTranslationKeys.configurationLastApproverDeleteTooltip,);

  return (
    <Box ref={setNodeRef} style={style} sx={approverRowSx}>
      <Box {...attributes} {...listeners} sx={getDragHandleSx(disabled)}>
        <DragIndicatorIcon fontSize="small" />
      </Box>
      <Typography variant="body2" sx={getApproverTextSx(disabled)}>
        <Box component="span" sx={approverIndexSx}>
          {index + 1}.
        </Box>
        {approver.label}
      </Typography>
      <Tooltip title={deleteDisabled ? deleteTooltip : ''} placement="top">
        <span>
          <IconButton
            size="small"
            onClick={onDelete}
            disabled={disabled || deleteDisabled}
            sx={deleteButtonSx}
            data-qa={`remove-approver-${approver._id}`}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
}
